import {
  Popover,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverProps,
  PopoverTrigger,
} from '@chakra-ui/react';
import React from 'react';

import { QuestionOutlineIcon } from '@/components/uiParts';

import { CmBox, CmIconButton } from '..';

type Props = {
  wrapSize?: 'none' | 'size-600';
  title?: string;
  iconSize?: 'md' | 'lg' | 'sm' | 'xs';
} & PopoverProps;

export const CmHelpPopover: React.FC<Props> = ({
  children,
  wrapSize = 'none',
  placement = 'left-start',
  title,
  iconSize = 'sm',
}) => {
  return (
    <div className={`cm-help-popover ${wrapSize}`}>
      <Popover {...{ placement }}>
        <PopoverTrigger>
          <CmIconButton
            size={iconSize}
            borderColor="gray.600"
            variant="outline"
            icon={<QuestionOutlineIcon color="gray.600" />}
            aria-label="help message"
          />
        </PopoverTrigger>
        {/*
         // @ts-ignore TS2590 */}
        <PopoverContent>
          <PopoverCloseButton size="lg" mt="-3px" marginRight="-7px" />
          {title !== undefined ? (
            <PopoverHeader>{title}</PopoverHeader>
          ) : (
            <CmBox height="35px" />
          )}
          <PopoverBody>{children}</PopoverBody>
        </PopoverContent>
      </Popover>
    </div>
  );
};
